<template>
    <main>
        <div class="container px-2 px-md-3 pg-inter-produtos">
            <div class="sombra-direita"></div>
            <div class="sombra-esquerda"></div>
            <div class="principal bg-white my-4">
                <div class="col-md-12 text-center card-header py-3 bg-light">

                    <div class="d-flex flex-column flex-md-row justify-content-center align-items-center">
                        <span class="mr-2"><strong>Número do Pedido: </strong></span>
                        <span class="text-primary py-2 px-3 bg-white rounded-pill"> {{ pedido.numeroPedido}}</span>
                    </div>

                </div>

                <div class="d-flex flex-column align-items-center">
                    <img :src="pedido ? pedido.pedidoPagamentoPix.imagemBase64 ? 'data:image/jpeg;base64,' + pedido.pedidoPagamentoPix.imagemBase64 : '' : ''" class="w-40" alt="qrCode" />
                    <strong>O código é válido até {{ pedido ? pedido.pedidoPagamentoPix ? pedido.pedidoPagamentoPix.dataDeValidade : '' : '' }}</strong>
                </div>


                <div class="d-flex flex-column align-items-center">
                    <ol>
                        <li>Abra o app do banco de sua preferência e escolha a opção <strong>pagar com Pix</strong></li>
                        <li>Escolha a opção copiar código Pix ou escaneie o código QR Code</li>
                        <li>Confira as informações de pagamento e confirme a compra</li>
                    </ol>
                </div>

                <div class="d-flex flex-column flex-md-row align-items-center dados-recebedor-pix col-md-8 mx-auto">

                    <div class="d-flex align-items-center">
                        <img :src="getImagem('LOGOPIX')" alt="logo_pix" class="logo-pix-modal" />
                    </div>
                    <span class="ml-3">
                        <span class="d-block"><strong>Dados do recebedor Pix:</strong></span>
                        Editora CNA Cultural Norte Americana S/A - CNPJ: 58.062.779/0001-50
                    </span>

                </div>
                <div class="d-flex flex-column align-items-center">
                    <div class="col-md-6">
                        <label class=""><strong>Responsável:</strong></label>
                        <span> {{pedido.nome}}</span>
                    </div>

                    <div class="col-md-6" v-for="item in pedido.collectionPessoaProduto">
                        <label class=""><strong>Nome Destinatário:</strong></label>
                        <span> {{item.nomeDestinatario}}</span>
                    </div>

                    <div class="col-md-6">
                        <h5>
                            <label class=""><strong>Valor:</strong></label>
                            {{ formatPrice(pedido.valorLiquido) }}
                        </h5>
                    </div>

                    <div class="buttons">
                        <button class="class= btn btn-outline-primary mr-2" @click="imprimir">
                            Imprimir
                        </button>
                        <a href="/home" class="btn btn-outline-secondary">
                            Voltar
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import { Api } from '@/common/api'
    import LOGOPIX from "../../assets/images/logo-pix.png"
    export default {
        name: 'imprimepedidopix',
        layouts: {
            default: ''
        },
        data() {
            return {
                pedido: null
            }
        },
        methods: {
            getPedido() {
                console.log(this.$route);
                new Api('pedido')
                    .get({ pedidoId: this.$route.params.filter.pedidoId })
                    .then(data => {
                        this.pedido = data.dataList[0]
                        console.log(this.pedido);
                    })
            },

            getImagem(nomeImagem) {
                switch (nomeImagem) {
                    case "LOGOPIX":
                        return LOGOPIX;
                }
            },

            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return 'R$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            imprimir() {
                window.print()
            },
        },
        mounted() {
            this.getPedido();
        }
    }
</script>
<style scoped="scss">

    .logo-pix-modal {
        width: 2rem;
        height: 2rem;
    }

    .dados-recebedor-pix {
        border: 1px solid #64D8CD;
        padding: 1rem;
        border-radius: 5px 5px;
        margin-bottom: .5rem;
    }

    .buttons{
        margin-bottom: 2rem;
    }
    .card-header{
        margin-top:5rem;
    }
</style>